<ng-template #testAlert>
  <div id="feed-test">
    <div class="modal-header p-2 header-panel">
      <div class="text" style="width: -webkit-fill-available">
        <h3 class="m-0">
          {{ "feed-test.results-title" | translate }}
          <span
            class="badge badge-dark position-absolute c-pointer help-badge"
            placement="bottom"
            ngbTooltip="{{ 'tooltip.test' | translate }}."
            >?</span
          >
        </h3>
      </div>
      <h3 class="m-0 c-pointer" (click)="closeModal()">&times;</h3>
    </div>
    <div class="w-100 text-center mt-2">
      <p class="mb-0 font-11">
        <b>{{ "alerts.general.subtitle" | translate }}.</b>
      </p>
    </div>

    <div class="modal-body p-1 p-md-4">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-4 col-xl-4">
          <small>{{ "filter.status" | translate }}</small>
          <select
            class="form-control"
            name="status"
            id="status"
            [(ngModel)]="filters.status"
            (ngModelChange)="filterPonds()"
          >
            <option value="">{{ "general.all" | translate }}</option>
            <option value="error">{{ "filter.error" | translate }}</option>
            <option value="done">{{ "filter.done" | translate }}</option>
            <option value="loading">{{ "filter.loading" | translate }}</option>
          </select>
        </div>
        <div class="col-12 col-md-6 col-lg-4 col-xl-4">
          <small>{{ "filter.name" | translate }}</small>
          <input
            class="form-control"
            type="text"
            [(ngModel)]="filters.name"
            name="name"
            (ngModelChange)="filterPonds()"
          />
        </div>

        <div class="col-12 col-md-6 col-lg-4 col-xl-4 d-flex justify-content-end">
          <div class="d-flex align-items-center">
            <button class="btn btn-warning mr-2" (click)="register('refeed')">
              {{ "feed.re-send" | translate }}
            </button>
            <button class="btn btn-primary" (click)="register('feed')">{{ "feed-test.send-ration" | translate }}</button>
          </div>
        </div>
      </div>
      <div class="row mt-3 mb-5" style="height: 500px">
        <div class="col-12">
          <ng-container *ngIf="validateData(); else noData">
            <div *ngFor="let pond of filteredPonds">
              <div style="height: 500px; overflow: auto">
                <div *ngFor="let feeder of pond.linked_feeders">
                  <b>{{feeder.name}}</b>
                  <app-view-alert [feeder]="feeder" [mode_test]="mode"></app-view-alert>
                  <hr />
                </div>
              </div>
            </div>
          </ng-container>

          <ng-template #noData>
            <div class="center h-100">
              <p>{{ "feed-test.no-feeders-to-show" | translate }}</p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-template>
